import InputField from 'customField/InputField';
import { Field, Form, Formik } from 'formik';
import Timer from 'helpers/setTimer';
import { cloneDeep, isEmpty } from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';

const SearchBar = ({ handleSearch, setContent }) => {
  //! State
  const timer = new Timer();
  const [openSearchOptions, setOpenSearchOptions] = useState(false);
  const [searchOptions, setSearchOptions] = useState([]);
  const formikRef = useRef();

  //! Function
  const onSearch = useCallback(
    (e) => {
      timer.debounce(() => {
        if (e.target.value !== '' && !openSearchOptions) setOpenSearchOptions(true);
        const options = handleSearch(e.target.value);
        setSearchOptions(options);
      }, 300);
    },
    [handleSearch, timer, openSearchOptions]
  );

  const handleSelect = useCallback(
    (option) => {
      const nextOption = cloneDeep(option);

      const index = nextOption?.content.slice(nextOption?.index).indexOf('>');

      //* Insert destination to scroolTo
      const insertText = '<div id="destination" ></div>';
      nextOption.content =
        nextOption?.content.slice(0, nextOption?.index) +
        '<strong style="background:#44a3ff; color:#000">' +
        nextOption?.content.slice(nextOption?.index, nextOption?.index + index + 1) +
        '</strong>' +
        insertText +
        nextOption?.content.slice(nextOption?.index + index + 1);

      setContent(nextOption);
    },
    [setContent]
  );

  useEffect(() => {
    const handleClick = async (e) => {
      const value = formikRef?.current?.values?.searchValues;
      if (e.target.classList.contains('search-input') && value !== '') setOpenSearchOptions(true);
      else {
        const search = document.getElementById('search-options');
        if (search) {
          search.classList.add('search-options-close');
          await new Promise((resolve) => setTimeout(resolve, 300));
          setOpenSearchOptions(false);
        }
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  //! Render
  return (
    <div className='guideline-search'>
      <div></div>
      <Formik
        innerRef={formikRef}
        initialValues={{
          searchValues: '',
        }}
      >
        {({ values }) => {
          return (
            <Form>
              <div style={{ position: 'relative' }}>
                <Field
                  component={InputField}
                  name='searchValues'
                  placeholder='Input to search...'
                  className='search-input'
                  onChangeCustomize={onSearch}
                  enableDefaultOnChange
                  addOnText={<i className='fa fa-search' />}
                  addOnType='append'
                />
                {openSearchOptions && (
                  <div className='search-options mt-2' id='search-options'>
                    {!isEmpty(searchOptions) ? (
                      searchOptions.map((option, index) => {
                        return (
                          <div
                            className='search-options__item'
                            key={`${option?.id}-${index}`}
                            onClick={() => handleSelect(option)}
                          >
                            <div className='info'>
                              <div>
                                Feature: <strong>{option?.inTab}</strong>
                              </div>
                              {option.inText()}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div style={{ padding: '20px' }}>No result</div>
                    )}
                  </div>
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
      <div></div>
    </div>
  );
};

export default SearchBar;
